import React from 'react';
import AppHeader from './AppHeader';

// Applying the deep purple theme globally via this layout
const Layout = ({ loginResults, children }) => {
  return (
    <div className="bg-gradient-custom min-h-screen text-white font-sans">
      <AppHeader isSuperUser={loginResults?.isSuperUser} loginResults={loginResults} />
      <main className="w-full">
        {children}
      </main>
    </div>
  );
};

export default Layout;
